import { render, staticRenderFns } from "./CurrentOutlined.vue?vue&type=template&id=1b529deb&scoped=true&"
import script from "./CurrentOutlined.vue?vue&type=script&lang=ts&"
export * from "./CurrentOutlined.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentOutlined.vue?vue&type=style&index=0&id=1b529deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b529deb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VIcon,VImg,VSkeletonLoader})
